import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

/* 获取部门列表 */
export const getDepartmentData = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/dept/${data.companyId}/${data.page}/${data.size}`
  })
}
/* 新增部门 */
export const addDepartment = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/dept`,
    method: 'post',
    data
  })
}
/* 搜索部门 */
export const serMatesByDepartment = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/dept/${data.companyId}/${data.page}/${data.size}?keyword=${data.keyword}`
  })
}
/* 删除部门  */
export const delDepartment = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/dept/${data.companyId}/${data.deptId}`,
    method: 'delete'
  })
}
/* 修改部门  */
export const editDepartment = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/dept`,
    method: 'put',
    data
  })
}
/* 修改部门  */
export const getDepartment = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/dept/${data.companyId}`
  })
}
